import { Box, Center, Heading } from '@chakra-ui/react';

function BannerBar(title: any, logo: any) {
  return (
    <>
    <Box
      as="section"
      position="absolute" // 使用 absolute 脫離父層 layout 流
      left="0"
      width="100%"        // 貼齊最左側並佔滿寬度
      height="150px"
      backgroundImage={logo}
      backgroundSize="cover"
      backgroundPosition="center"
    >
      <Center h="100%" bg="blackAlpha.400">
        <Heading color="white">{title}</Heading>
      </Center>
    </Box>
    <Box height="150px" />
    </>
  );
}

export default BannerBar;
